import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Image } from 'components/core/Image';

const SIZE_DIMENSIONS = {
    small: { width: '320', height: '180' },
    medium: { width: '480', height: '270' },
    large: { width: '640', height: '360' },
    xlarge: { width: '800', height: '450' },
};

const WEBP_CONVERTIBLE_EXT = /\.(jpe?g|png)(?=$|[?#])/i;

function getWebpSrc(src) {
    if (!src) {
        return null;
    }
    if (!WEBP_CONVERTIBLE_EXT.test(src)) {
        return null;
    }
    return src.replace(WEBP_CONVERTIBLE_EXT, '.webp');
}

function FacilityImageBase({ webpSrc, src, lazyLoad, ...imageProps }) {
    // Skip webp when lazyLoad=false (e.g., map popups) to avoid 403 errors
    const useWebp = lazyLoad !== false && webpSrc;

    return (
        <picture>
            {useWebp && <source srcSet={webpSrc} type="image/webp" />}
            <Image src={src} lazyLoad={lazyLoad} {...imageProps} />
        </picture>
    );
}

FacilityImageBase.propTypes = {
    webpSrc: PropTypes.string,
    src: PropTypes.string,
    lazyLoad: PropTypes.bool,
};

export const enhance = connect(({ app }, { src, size, lazyLoad }) => {
    const resolvedSize = size || 'small';
    const dimensions = SIZE_DIMENSIONS[resolvedSize] || SIZE_DIMENSIONS.small;
    const filename = src || 'default-sparefoot-photo.jpg';
    const baseSrc = `${app.cloudfrontUrl}/${resolvedSize}-compress/${filename}`;
    const webpSrc = getWebpSrc(baseSrc);

    return {
        src: baseSrc,
        webpSrc,
        className: 'facility-image',
        width: dimensions.width,
        height: dimensions.height,
        lazyLoad,
    };
});

export default enhance(FacilityImageBase);